<template>
  <main id="main-content" class="product">
    <div>
      <div class="wp-block-columns active">
        <div class="wp-block-column">
          <div :class="{'product-gallery': true, 'sold-out': sold_out}" :data-sold-out="trans.sold_out">
            <div
              id="current-image"
              class="current-image"
              :style="gallery.style"
            >
              <img :src="product_data.img.src" />
            </div>

            <ul v-if="product_data.images">
              <li
                v-for="(image, key, index) in product_data.images"
                :key="image.uuid"
                :style="{ backgroundImage: 'url(' + image.src + ')' }"
                :data-img="image.src"
                :data-index="index"
                :class="{ current: index == 0 }"
                @click="handleChangeImage"
              >
                <img :src="image.src" />
              </li>
            </ul>
          </div>
        </div>
        <div class="wp-block-column">
          <h2>{{ product_data.title }}</h2>

          <p class="price">{{ product_data.price }}</p>

          <div class="product-add">
            <input
              name="add-count"
              v-model="order_count"
              :value="order_count"
            />
            <button :disabled="sold_out" name="add-to-cart" @click="addToCart">
              Dodaj do koszyka
            </button>
          </div>

          <div class="desc" v-html="product_data.description"></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
let touchsurface = null,
  startX,
  startY,
  dist,
  threshold = 150,
  allowedTime = 400,
  elapsedTime,
  startTime;

export default {
  name: "Product",
  data() {
    return {
      sold_out: false,
      quantity: 0,
      order_count: 1,
      selected_variant_id: null,
      gallery: {
        style: {
          backgroundImage: "none",
        },
        current_image_index: 0,
      },
        trans: {
            sold_out: window.APP_INFO.trans.sold_out,
        }
    };
  },
  props: {
    product_data: {
      type: Array,
      required: false,
    },
  },
  methods: {
    addToCart(e) {
      console.log(e);
      console.log("to order " + this.order_count);
      console.log("dostepnosc " + this.quantity);
      if (parseInt(this.quantity, 10) >= parseInt(this.order_count, 10)) {
        this.$emit("shoplo_add_product_cart", {
          variant_id: this.selected_variant_id,
          quantity: this.order_count,
        });
      } else {
        alert("not enough");
      }
    },
    handleChangeImage(e) {
      this.setGalleryImage(
        e.target.getAttribute("data-index"),
        e.target.getAttribute("data-img")
      );
    },
    setGalleryImage(index, img) {
      const vm = this;
      vm.gallery.current_image_index = index;

      if (img == null) {
        let $all_elements = document.querySelectorAll(
          ".product-gallery [data-index]"
        );

        let i;
        for (i = 0; i < $all_elements.length; i++) {
          $all_elements[i].classList.remove("current");
        }
        let $index_element = document.querySelector(
          '.product-gallery [data-index="' + index + '"]'
        );
        img = $index_element.getAttribute("data-img");
        $index_element.classList.add("current");
      }

      vm.gallery.style.backgroundImage = "url('" + img + "')";
    },
  },
  created() {
    const vm = this;

    console.log("product created");
    console.log(vm.product_data);
    console.log(vm.product_data.img);
    let iter = null;
    for (iter = 0; iter < vm.product_data.variants.length; iter++) {
      if (vm.product_data.variants[iter].quantity > 0) {
        vm.quantity = vm.product_data.variants[iter].quantity;
        vm.selected_variant_id = vm.product_data.variants[iter].id;
        break;
      }
    }

        if(vm.quantity === 0) {
            vm.sold_out = true;
        }

    vm.setGalleryImage(0, vm.product_data.img.src);
    //vm.gallery.style.backgroundImage = 'url(\'' + vm.product_data.img.src + '\')';
    //vm.showVideo(vm.content.page)
  },
  mounted() {
    const vm = this;
    console.log("product mounted");

    setTimeout(function () {
      touchsurface = document.getElementById("current-image");

      touchsurface.addEventListener(
        "touchstart",
        function (e) {
          let touchobj = e.changedTouches[0];
          dist = 0;
          startX = touchobj.pageX;
          startY = touchobj.pageY;
          startTime = new Date().getTime(); // record time when finger first makes contact with surface
          e.preventDefault();
        },
        false
      );

      touchsurface.addEventListener(
        "touchmove",
        function (e) {
          e.preventDefault(); // prevent scrolling when inside DIV
        },
        false
      );

      touchsurface.addEventListener(
        "touchend",
        function (e) {
          var touchobj = e.changedTouches[0];
          dist = touchobj.pageX - startX;
          elapsedTime = new Date().getTime() - startTime;

          if (
            elapsedTime <= allowedTime &&
            Math.abs(touchobj.pageY - startY) <= 100
          ) {
            let gallery_objects_count = Object.keys(vm.product_data.images).length;
            let new_index = null;

            if (dist > 0) {
              //previous
              //console.log('prev of ' + vm.gallery.current_image_index + ' from ' + gallery_objects_count);
              if (vm.gallery.current_image_index > 0) {
                new_index = vm.gallery.current_image_index - 1;
              } else {
                new_index = gallery_objects_count - 1;
              }
            } else {
              //next
              //console.log('next of ' + vm.gallery.current_image_index + ' from ' + gallery_objects_count);
              if (gallery_objects_count > vm.gallery.current_image_index + 1) {
                new_index = vm.gallery.current_image_index + 1;
              } else {
                new_index = 0;
              }
            }

            vm.setGalleryImage(new_index);
          }

          e.preventDefault();
        },
        false
      );
    }, 600);
  },
  updated() {
    console.log("product updated");
  },
};
</script>